import { PageLayout } from "../page-layout";

export const LoadingIndicator = () => {
  return (
    <PageLayout
      wrapperStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span
        style={{
          color: "#fff",
        }}
      >
        Carregando...
      </span>
    </PageLayout>
  );
};
